'use strict';
// import { API_BASE_URL, GET_ALL_PRODUCT } from './global';
"use strict";
//  export const API_BASE_URL: string = 'localhost:8090/tripleplay';   // local
 export const API_BASE_URL: string = 'ekyc.tripleplay.in:8090/tripleplay';
// export const API_BASE_URL: string = "ekyc.arminfo.in:8090/tripleplay";
// export const API_BASE_URL:string = "192.168.0.160:8080/tripleplay"; //vipin   local
// export const API_BASE_URL = "103.21.187.3:8090/tripleplay";
// export const API_BASE_URL = "ekyc.arminfo.in:8090/tripleplay";

export const value: string = "true";
export const GET_LOGIN_URL: string =
  "http://" + API_BASE_URL + "/users/loginnew";
export const GET_ALL_CITY_URL: string =
  "http://" + API_BASE_URL + "/cities/all";
export const UPLOAD_CITY_EXCEL: string =
  "http://" + API_BASE_URL + "/cities/readFromExcel";

export const DEL_CITY_BY_ID_URL: string = "http://" + API_BASE_URL + "/cities/";
export const SAVE_CITY_URL: string = "http://" + API_BASE_URL + "/cities/save";
export const UPDATE_CITY_URL: string = "http://" + API_BASE_URL + "/cities/update";
export const GET_CITY_BY_ID_URL: string = "http://" + API_BASE_URL + "/cities/";

export const GET_ALL_COMPANY_BRANCHES: string =
  "http://" + API_BASE_URL + "/company/all";

export const UPDATE_ONLINE_PAYMENT: string =
  "http://" + API_BASE_URL + "/mobilePay/ekycBillRequest";

export const RAZORPAY_PAYMENT: string =
  "http://" + API_BASE_URL + "/payGate/ekycBillRequest";

export const UPDATE_EKYC_CAF_PAYMENT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/update";

export const SAVE_EKYC_CAF_PAYMENT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/save";

export const SAVE_COMPANY_URL: string =
  "http://" + API_BASE_URL + "/company/save";

export const DEL_COMPANY_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/company/";
export const UPDATE_COMPANY_URL: string =
  "http://" + API_BASE_URL + "/company/update";
export const GET_COMPANY_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/company/";

export const GET_ALL_COMPANY_SERVICES: string =
  "http://" + API_BASE_URL + "/services/all";
export const SAVE_COMPANY_SERVICE: string =
  "http://" + API_BASE_URL + "/services/save";
export const UPDATE_COMPANY_SERVICE: string =
  "http://" + API_BASE_URL + "/services/update";
export const DELETE_COMPANY_SERVICE: string =
  "http://" + API_BASE_URL + "/services/";

export const GET_AREA_BY_CITY_ID: string =
  "http://" + API_BASE_URL + "/areas/city/";
export const SAVE_CITY_AREA: string = "http://" + API_BASE_URL + "/areas/save";
export const UPDATE_CITY_AREA: string =
  "http://" + API_BASE_URL + "/areas/update";
export const DEL_CITY_AREA: string = "http://" + API_BASE_URL + "/areas/";
export const GET_AREA_BY_AREA_ID: string = "http://" + API_BASE_URL + "/areas/";

//subarea
export const GET_ALL_SUBAREA_URL: string =
  "http://" + API_BASE_URL + "/subArea/all";
export const GET_SUBAREA_BY_AREAID_URL: string =
  "http://" + API_BASE_URL + "/subArea/area/";
export const SAVE_SUBAREA_URL: string =
  "http://" + API_BASE_URL + "/subArea/save";
export const UPDATE_SUBAREA_URL: string =
  "http://" + API_BASE_URL + "/subArea/update";
export const DELETE_SUBAREA_URL: string =
  "http://" + API_BASE_URL + "/subArea/";

// /subArea/all
export const GET_ALL_PLANS: string = "http://" + API_BASE_URL + "/plans/all";
export const GET_ALL_INACTIVE_PLANS: string = "http://" + API_BASE_URL + "/plans/all?active=";
export const UPDATE_PLAN_ACTIVE_STATUS: string = "http://" + API_BASE_URL + "/plans/updateActiveStatus";

export const DEL_PLAN_BY_PLAN_ID: string = "http://" + API_BASE_URL + "/plans/";

export const GET_ALL_SALESMAN: string = "http://" + API_BASE_URL + "/plans/all";

export const GET_ALL_VENDOR: string = "http://" + API_BASE_URL + "/vendor/all";

export const SAVE_NEW_VENDOR: string =
  "http://" + API_BASE_URL + "/vendor/save";
export const UPDATE_VENDOR: string =
  "http://" + API_BASE_URL + "/vendor/update";
export const DELETE_VENDOR: string = "http://" + API_BASE_URL + "/vendor/";
export const GET_VENDOR_BY_ID: string = "http://" + API_BASE_URL + "/vendor/";

export const GET_ALL_USER: string = "http://" + API_BASE_URL + "/users/all";
export const DEL_USER_BY_USER_ID: string = "http://" + API_BASE_URL + "/users/";
export const SAVE_NEW_USER: string = "http://" + API_BASE_URL + "/users/save";
export const UPDATE_USER_ACTIVE_STATUS: string = "http://" + API_BASE_URL + "/users/updateActiveStatus";

// tripleplay/users/updateActiveStatus
export const GET_ALL_ROLES: string = "http://" + API_BASE_URL + "/role/all";
export const SAVE_NEW_ROLES: string = "http://" + API_BASE_URL + "/role/save";
export const DEL_ROLE_NAME: string = "http://" + API_BASE_URL + "/role/";
export const UPDATE_ROLE_NAME: string =
  "http://" + API_BASE_URL + "/role/update";

export const GET_DEP_BY_COMPANY_ID_URL: string =
  "http://" + API_BASE_URL + "/department/company/";
export const SAVE_COMPANY_DEPARTMENT_URL: string =
  "http://" + API_BASE_URL + "/department/save/";
export const UPDATE_COMPANY_DEPARTMENT_URL: string =
  "http://" + API_BASE_URL + "/department/update/";
export const DELETE_COMPANY_DEPARTMENT_URL: string =
  "http://" + API_BASE_URL + "/department/";
export const GET_DETPARTMENT_BY_ID: string =
  "http://" + API_BASE_URL + "/department/";
export const GET_ALL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/customers/all";

export const GET_SERVICE_BY_ID: string =
  "http://" + API_BASE_URL + "/services/";

export const GET_ALL_CATEGORY: string =
  "http://" + API_BASE_URL + "/category/all";
export const SAVE_CATEGORY_URL: string =
  "http://" + API_BASE_URL + "/category/save";
export const UPDATE_CATEGORY_URL: string =
  "http://" + API_BASE_URL + "/category/update";
export const GET_CATEGORY_BY_ID: string =
  "http://" + API_BASE_URL + "/category/";

export const GET_ALL_AREAS: string = "http://" + API_BASE_URL + "/areas/all";


export const SAVE_NEW_PLAN: string = "http://" + API_BASE_URL + "/plans/save";
export const UPDATE_PLAN_URL: string =
  "http://" + API_BASE_URL + "/plans/update";
export const GET_PLAN_BY_ID_URL: string = "http://" + API_BASE_URL + "/plans/";

export const UPDATE_USER_URL: string =
  "http://" + API_BASE_URL + "/users/update";

export const GET_PRODUCT_ITEM_BY_CATEGORY_ID: string =
  "http://" + API_BASE_URL + "/product/category/";
export const POST_PRODUCT_API: string =
  "http://" + API_BASE_URL + "/product/save";
/* export const FILE_UPLOAD_URL: string = 'http://default-environment.dnvv7k2pbr.ap-south-1.elasticbeanstalk.com/belue/uploadFile/'; */

export const UPLOAD_IMAGE_URL: string =
  "http://" + API_BASE_URL + "/uploadFile/";

export const UPLOAD_OLD_INSTALL_INVENTORY: string =
  "http://" + API_BASE_URL + "/oldInstallInventory/uploadExcel";

export const DELETE_PRODUCT_ITEM_API: string =
  "http://" + API_BASE_URL + "/product/";
export const GET_PRODUCT_ITEM_BY_ID_API: string =
  "http://" + API_BASE_URL + "/product/";

export const GET_USER_BY_USERID: string = "http://" + API_BASE_URL + "/users/";
export const GET_USERS_BY_SEARCH: string =
  "http://" + API_BASE_URL + "/users/allpage";
export const GET_ATTENDANCE_USERS_BY_SEARCH: string =
  "http://" + API_BASE_URL + "/users/allpage";
export const GET_USERS_BY_MOBILE_SEARCH: string =
  "http://" + API_BASE_URL + "/users/allpage";
//GET_USER_BY_ID
export const GET_USER_BY_ID: string = "http://" + API_BASE_URL + "/users/";
export const GET_MANAGER_BY_SEARCH: string =
  "http://" + API_BASE_URL + "/users/allpage";

export const RESET_USER_DEVICE_ID: string =
  "http://" + API_BASE_URL + "/users/reset";

export const UPDATE_PRODUCT_URL: string =
  "http://" + API_BASE_URL + "/product/update";

export const DELETE_CATEGORY_API: string =
  "http://" + API_BASE_URL + "/category/";

export const GET_ALL_CUSTOMER_DOCUMENTS: string =
  "http://" + API_BASE_URL + "/customers/";

export const GET_ALL_TASK: string = "http://" + API_BASE_URL + "/tpTask/all";
// tpTask/updateStatus
export const UPDATE_STATUS_TASK_URL: string =
  "http://" + API_BASE_URL + "/tpTask/updateStatus";
export const UPDATE_WHATSAPP_LINK_STATUS_URL: string =
  "http://" + API_BASE_URL + "/tpTask/sharedWhatsappLink";
export const GET_TASK_BY_ID: string = "http://" + API_BASE_URL + "/tpTask/";
export const SAVE_TASK_URL: string = "http://" + API_BASE_URL + "/tpTask/save";
export const UPDATE_TASK_URL: string =
  "http://" + API_BASE_URL + "/tpTask/update";
export const DELETE_TASK_URL: string = "http://" + API_BASE_URL + "/tpTask/";

export const GET_BY_TASK_DATE_URL: string =
  "http://" + API_BASE_URL + "/tpTask/all?";

export const GET_TASK_STATUS_URL: string =
  "http://" + API_BASE_URL + "/tpTask/statusAndAssignedEmp?status=";

export const FITLER_TASK_URL: string =
  "http://" + API_BASE_URL + "/tpTask/filter?";

export const TASK_STATS_URL: string =
  "http://" + API_BASE_URL + "/tpTask/stats?";

export const INVENTORY_CHECKIN_SAVE: string =
  "http://" + API_BASE_URL + "/inventory/save";
export const INVENTORY_CHECKIN_UPDATE_CHECKOUT: string =
  "http://" + API_BASE_URL + "/inventory/updateConfirmStatus";
export const INVENTORY_ASSIGN_UPDATE_CONFIRM: string =
  "http://" + API_BASE_URL + "/inventory/assign/updateConfirmed";
export const GET_INVENTORY_BY_ID: string =
  "http://" + API_BASE_URL + "/inventory/";
export const INVENTORY_CHECKIN_UPDATE: string =
  "http://" + API_BASE_URL + "/inventory/update";
export const GET_ALL_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventory/all";
export const GET_ALL_INVENTORY_QUERY: string =
  "http://" + API_BASE_URL + "/inventory/all?query=";
export const FILTER_STOCK_INVENTORY_QUERY: string =
  "http://" + API_BASE_URL + "/inventory/all?query=";

export const GET_ALL_ATTENDANCE: string =
  "http://" + API_BASE_URL + "/userAttendance/all";
export const GET_ALL_ATTENDANCE_EXCEL: string =
  "http://" + API_BASE_URL + "/userAttendance/dates?from=";
export const GET_ATTENDANCE_BY_USER_ID: string =
  "http://" + API_BASE_URL + "/userAttendance/all";
export const SAVE_USER_ATTENDANCE: string =
  "http://" + API_BASE_URL + "/userAttendance/save";
export const UPDATE_USER_ATTENDANCE: string =
  "http://" + API_BASE_URL + "/userAttendance/update";
export const SAVE_USER_LIST_ATTENDANCE: string =
  "http://" + API_BASE_URL + "/userAttendance/saveList";
export const GET_ALL_EMPLOYEE_BY_REPORTING_MANAGER: string =
  "http://" + API_BASE_URL + "/userAttendance/reportingManager?managerId=";
export const GET_ALL_EMPLOYEE_EXCEL_FORMAT: string =
  "http://" + API_BASE_URL + "/userAttendance/excelFormat?managerId=";

export const GET_INVENTORY_DETAILS_BY_PRODUCT_ID: string =
  "http://" + API_BASE_URL + "/inventory/details/";
export const GET_INVENTORY_UNASSIGNED_ITEMS: string =
  "http://" + API_BASE_URL + "/inventory/query";
export const INVENTORY_QUERY_API: string =
  "http://" + API_BASE_URL + "/inventory/query";
export const INVENTORY_HISTORY_BY_ASSIGNED_TYPE: string =
  "http://" + API_BASE_URL + "/inventory/query/byAssignedType";
export const INVENTORY_HISTORY_PAGES_ASSIGNED_TYPE: string =
  "http://" + API_BASE_URL + "/inventory/query/byAssignedType?";

export const GET_CUSTOMER_BY_PAGE: string =
  "http://" + API_BASE_URL + "/customers/all?";
export const GET_CUSTOMER_BY_STATUS_PAGE: string =
  "http://" + API_BASE_URL + "/customers/assignToEmployeeOrStatus?status=";
export const GET_CUSTOMER_BY_TAB_PAGE: string =
  "http://" + API_BASE_URL + "/customers/assignToEmployeeOrStatus?";
export const REUPDATE_COMPLETE_CAF: string =
  "http://" + API_BASE_URL + "/customers/reUpdateCompleted";

export const GET_PAYMENT_LATER_CUSTOMER: string =
  "http://" + API_BASE_URL + "/customers/paymentPending?paymentDone=true";
export const UPDATE_PAYMENT_LATER_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updatePaymentStatus";
export const GET_PAYMENTS_STATUS_CUSTOMER_BY_PAGE: string =
  "http://" + API_BASE_URL + "/customers/all/status?paymentStatus=";
export const GET_EKYC_STATUS_CUSTOMER_BY_PAGE: string =
  "http://" + API_BASE_URL + "/customers/all/status?ekycStatus=";
export const UPDATE_CUSTOMER_PAYMENT_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updatePaymentStatus";
export const UPDATE_CUSTOMER_EKYC_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updateEkycStatus";
export const GET_WORK_STATUS_CUSTOMER_BY_PAGE: string =
  "http://" + API_BASE_URL + "/customers/all/workStatus?status=";
export const UPDATE_CUSTOMER_WORK_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updateWorkStatus";
export const UPDATE_EKYC_CUSTOMER_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updateStatus";
export const UPDATE_FOLLOWUP_CUSTOMER_STATUS: string =
  "http://" + API_BASE_URL + "/ekycFollowUpHistory/save";
export const GET_EKYC_REPORT_STATUS: string =
  "http://" + API_BASE_URL + "/customers/ekycReport?";
// /customers/ekycReport?from=30-03-2019&till=05-04-2019&status=PENDING_WIRING
export const GET_ALL_EKYC_PAYMENT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/all";
export const GET_EKYC_PAYMENT_FILTER: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/filter?";
export const UPDATE_EKYC_PAYMENT_SUMMARY_STAT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/updateAmount"; ``
export const GET_EKYC_PAYMENT_SUMMARY_STAT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/paymentStats?";
export const GET_EKYC_EMPLOYEE_PAYMENT_STAT:
  string = "http://" + API_BASE_URL + "/cafCustomerPayment/employeePaymentStats?";
export const GET_EKYC_DAY_BOOK_PAYMENT_RECEIVED_STATUS: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/dayBookReport?";

export const UPDATE_CUSTOMER_ACTIVE_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updateActiveStatus";
export const ASSIGN_SALESMAN_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventory/assign";
export const MULTIPLE_ASSIGN_SALESMAN_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventory/assign/saveMultiple";

// export const GET_ALL_BANK_BRANCH: string =
// "http://admin.tripleplay.in/api/webservice.asmx/BankList";
export const GET_USERS_BY_PAGE: string =
  "http://" + API_BASE_URL + "/users/allpage";
export const FILTER_USER_BY_QUERY: string =
  "http://" + API_BASE_URL + "/users/allpage";
export const GET_USER_BY_MOBILE_NUMBER: string =
  "http://" + API_BASE_URL + "/users/allpage";

export const Test_api_global: string =
  "http://" + API_BASE_URL + "/globaldata/";

export const GET_ALL_PARTNERS: string =
  "http://" + API_BASE_URL + "/partners/all";
export const GET_PARTNER_BY_PARTNER_ID: string =
  "http://" + API_BASE_URL + "/partners/";
export const SAVE_PARTNER: string = "http://" + API_BASE_URL + "/partners/save";
export const UPDATE_PARTNER: string =
  "http://" + API_BASE_URL + "/partners/update";
export const DELETE_PARTNER: string = "http://" + API_BASE_URL + "/partners/";

export const GET_CATEGORY_EMBED: string =
  "http://" + API_BASE_URL + "/category/all?embed=available,assigned";

export const GET_CUSTOMER_BY_ID: string =
  "http://" + API_BASE_URL + "/customers/";
export const UPDATE_EKYC_CUSTOMER_BY_ID: string =
  "http://" + API_BASE_URL + "/customers/update";
export const GET_CUSTOMER_BY_SUB_CAF_ID: string =
  "http://" + API_BASE_URL + "/subCafCustomers/";
export const REPLACE_CUSTOMER_PRODUCT: string =
  "http://" + API_BASE_URL + "/inventory/replacement";

// export const GET_CUSTOMER_BY_ID: string = "http://" + API_BASE_URL + "/customers/";

export const FILTER_INVENTORY_BY_QUERY: string =
  "http://" + API_BASE_URL + "/inventory/all?query=";
export const FILTER_CUSTOMER: string =
  "http://" + API_BASE_URL + "/customers/all?filter=";
export const FILTER_EKYC_CUSTOMER: string =
  "http://" + API_BASE_URL + "/customers/all?";
export const RETURN_CUSTOMER_PRODUCT: string =
  "http://" + API_BASE_URL + "/inventory/assign/returnByCustomer";

export const GET_ALL_REPLACEMENT: string =
  "http://" + API_BASE_URL + "/inventory/replacement/all";

export const VENDOR_CHECKOUT: string =
  "http://" + API_BASE_URL + "/inventory/save";

export const RETURN_BACK_FROM_REPLACEMENT: string =
  "http://" + API_BASE_URL + "/inventory/replacement/return";

export const GET_VENDOR_CHECKOUT_ITEMS: string =
  "http://" + API_BASE_URL + "/inventory/vendorCheckout?";

export const GET_ASSIGNED_EMPLOYEES: string =
  "http://" + API_BASE_URL + "/users/inventoryAssigned";

export const VENDOR_ACTIONS_API: string =
  "http://" + API_BASE_URL + "/inventory/vendorCheckout";

export const BY_ASSIGN_TYPE_FILTER: string =
  "http://" + API_BASE_URL + "/inventory/assign/all?";

export const BY_REVERT_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventoryHistory/all?";

export const BY_FILTERED_REVERT_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventoryHistory/filter?";

export const GET_ALL_PRODUCT_DETAILS: string =
  "http://" + API_BASE_URL + "/product/all";

export const DISTRIBUTION_API: string =
  "http://" + API_BASE_URL + "/inventory/detail/";

export const GET_DISTRIBUTION_BY_TYPECODE: string =
  "http://" + API_BASE_URL + "/inventory/distribution/detail?typeCode=";

export const GET_REPORT_STATS: string =
  "http://" + API_BASE_URL + "/inventory/distribution/report/stats";
export const GET_REPORT_DETAIL: string =

  "http://" + API_BASE_URL + "/inventory/distribution/report/detail";
export const GET_PRODUCT_SEARCH_DETAIL: string =
  "http://" + API_BASE_URL + "/inventory/subDetail?query=";

export const GET_GLOBAL_DATA: string =
  "http://" + API_BASE_URL + "/globaldata/";

export const GET_ALL_CHARGE_URL: string =
  "http://" + API_BASE_URL + "/masterCharge/all";

export const DEL_CHARGES_URL: string =
  "http://" + API_BASE_URL + "/masterCharge/";
export const UPDATE_CHARGE_URL: string =
  "http://" + API_BASE_URL + "/masterCharge/update";
export const POST_CHARGE_URL: string =
  "http://" + API_BASE_URL + "/masterCharge/save";
export const GET_CHARGE_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/masterCharge/";

//////////////////employeeRole
export const GET_ALL_EMPLOYEE_ROLE_URL: string =
  "http://" + API_BASE_URL + "/rolePermission/all";
export const DEL_EMPLOYEE_ROLE_URL: string =
  "http://" + API_BASE_URL + "/rolePermission/";
export const UPDATE_EMPLOYEE_ROLE_URL: string =
  "http://" + API_BASE_URL + "/rolePermission/update";
export const POST_EMPLOYEE_ROLE_URL: string =
  "http://" + API_BASE_URL + "/rolePermission/save";
export const GET_EMPLOYEE_ROLE_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/rolePermission/";

/////////////////product condition
export const GET_ALL_PRODUCT_CONDITION_URL: string =
  "http://" + API_BASE_URL + "/productMaster/all";
export const DEL_PRODUCT_CONDITION_URL: string =
  "http://" + API_BASE_URL + "/productMaster/";
export const UPDATE_PRODUCT_CONDITION_URL: string =
  "http://" + API_BASE_URL + "/productMaster/update";
export const SAVE_PRODUCT_CONDITION_URL: string =
  "http://" + API_BASE_URL + "/productMaster/save";
export const GET_PRODUCT_CONDITION_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/productMaster/";

// export const GET_EKYC_REPORT: string =
//   "http://" + API_BASE_URL + "/customers/totalCount";
export const PAYMENT_COLLECTION: string =
  "http://" + API_BASE_URL + "/crm/paymentCollection";
export const GET_PAYMENT_COLLECTION_REPORT: string =
  PAYMENT_COLLECTION + "/all?";
export const GET_PAYMENT_COLLECTION_REPORT_FILTER: string =
  PAYMENT_COLLECTION + "/filter?query=";
export const GET_NO_COLLECTION_REPORT: string =
  "http://" + API_BASE_URL + "/crm/noCollections/all?";
export const GET_NO_COLLECTION_REPORT_FILTER: string =
  "http://" + API_BASE_URL + "/crm/noCollections/filter?query=";
export const GET_USER_DETAIL = "http://" + API_BASE_URL + "/crm/account";
export const GET_USER_DETAIL_BY_NUMBER = "http://" + API_BASE_URL + "/crm/account";
//
export const GET_EMPLOYEE_BY_DATE =
  "http://" + API_BASE_URL + "/employeeTracking/created?date=";
export const GET_PAYMENT_STATUS: string = PAYMENT_COLLECTION + "/paymentStats?";
export const REVERT_POST_PAYMENT_COLLECTION_REPORT: string =
  PAYMENT_COLLECTION + "/revert";

// discountRule

export const GET_ALL_DISCOUNT_URL: string =
  "http://" + API_BASE_URL + "/promoCode/all";
export const GET__DISCOUNT_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/promoCode/";
export const ADD_DISCOUNT_URL: string =
  "http://" + API_BASE_URL + "/promoCode/save";
export const UPDATE_DISCOUNT_URL: string =
  "http://" + API_BASE_URL + "/promoCode/update";

////////////////////team
export const GET_ALL_TEAM_NAME_URL: string =
  "http://" + API_BASE_URL + "/teamMember/allTeam";
export const GET_ALL_TEAM_URL: string =
  "http://" + API_BASE_URL + "/teamMember/all";
export const GET_TEAM_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/teamMember/";
export const ADD_TEAM_URL: string =
  "http://" + API_BASE_URL + "/teamMember/save";
export const UPDATE_TEAM_URL: string =
  "http://" + API_BASE_URL + "/teamMember/update";



// funnel/

export const GET_ALL_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/all";
export const GET_FUNNEL_CUSTOMER_BY_ID: string =
  "http://" + API_BASE_URL + "/funnelCustomer/";
export const GET_FILTER_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/filter";
export const UPDATE_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/update";
export const SAVE_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/save";
export const DELETE_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/";
export const UPDATE_STATUS_FUNNEL_CUSTOMER: string =
  "http://" + API_BASE_URL + "/funnelCustomer/updateStatus";

export const GET_FUNNEL_CUSTOMER_BY_STATUS: string =
  "http://" + API_BASE_URL + "/funnelCustomer/statusAndAssignedEmp?status=";

////////followUp

export const GET_ALL_FOLLOWUP_URL: string =
  "http://" + API_BASE_URL + "/followUpHistory/all";
export const SAVE_FOLLOWUP_URL: string =
  "http://" + API_BASE_URL + "/followUpHistory/save";
export const GET_FOLLOWUP_BY_ID_URL: string =
  "http://" + API_BASE_URL + "/followUpHistory/";

// lead
export const GET_ALL_LEAD_URL: string = "http://" + API_BASE_URL + "/lead/all";
export const GET_LEAD_BY_ID_URL: string = "http://" + API_BASE_URL + "/lead/";
export const UPDATE_LEAD_URL: string =
  "http://" + API_BASE_URL + "/lead/update/";
export const SAVE_LEAD_URL: string = "http://" + API_BASE_URL + "/lead/save";
export const UPDATE_STATUS_LEAD_URL: string =
  "http://" + API_BASE_URL + "/lead/updateStatus";
export const GET_ALL_LEAD_BY_STATUS: string =
  "http://" + API_BASE_URL + "/lead/statusAndAssignedEmp?status=";
export const GET_LEAD__BY_ASSIGNED_TO_EMPLOYEE_URL: string =
  "http://" + API_BASE_URL + "/lead/assignedToEmployee?assignedToEmployeeId=";
export const GET_PAYMENT_RECEIVED_STATUS: string =
  PAYMENT_COLLECTION + "/recievedAmount?";
export const UPDATE_PAYMENT_STATS: string =
  PAYMENT_COLLECTION + "/updateStatus";
export const GET_EMPLOYEE_STATS: string = PAYMENT_COLLECTION + "/employeeStats";
export const UPDATE_EMPLOYEE_STATS: string =
  PAYMENT_COLLECTION + "/updateAmount";
export const GET_EMPLOYEE_TRACKING_BY_DATE: string =
  "http://" + API_BASE_URL + "/employeeTracking/dateAndEmployeeId";
export const GET_EMPLOYEE_TRACKING_DETAILS: string =
  "http://" + API_BASE_URL + "/employeeTracking/employeeAndTrackingDetails";
export const EDIT_ASSIGN_SALESMAN_INVENTORY: string =
  "http://" + API_BASE_URL + "/inventory/assign/updateMultiple";

export const GET_ALL_LEAD_FILTER: string =
  "http://" + API_BASE_URL + "/lead/filter";
export const CLOSE_LEAD_URL: string =
  "http://" + API_BASE_URL + "/lead/updateAmount";
export const GET_LEAD_CUSTOMER_BY_ID: string =
  "http://" + API_BASE_URL + "/lead/";

//reasons
export const FOLLOW_UP_REASON: string =
  "http://" + API_BASE_URL + "/followUpReasonMaster/";
export const ADD_REASON: string = FOLLOW_UP_REASON + "save";
export const GET_ALL_REASONS: string = FOLLOW_UP_REASON + "all";
export const EDIT_REASON: string = FOLLOW_UP_REASON + "update";


//reports
export const GET_ALL_DISCONNECTION_URL: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/filter";

export const CRM_STATS_URL: string =
  "http://" + API_BASE_URL + "/lead/enquiryAndLeadStats";

export const DISCONNECTION_STATS_URL: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/countStats";

export const COLLECTION_STATS_URL: string =
  "http://" + API_BASE_URL + "/crmStats/collectionStats";

export const EKYC_STATS_URL: string =
  "http://" + API_BASE_URL + "/customers/totalCount?";

//CRM CONNECTION DISCONNECTION
export const GET_ALL_CONNECTION_ISSUE_URL: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/filter";
export const UPDATE_CON: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/update";
export const GET_CON_BY_STATUS: string =
  "http://" +
  API_BASE_URL +
  "/crmDisconnectionRequest/statusAndAssignedToEmployee";
export const GET_CON_BY_ID: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/";

export const UPDATE_STATUS_COMPLAINT: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/updateStatus/";
////////////////////////crmstatsDashboard

export const GET_CRMSTATS_EMPLOYEESTATS: string =
  "http://" + API_BASE_URL + "/crmStats/employeeStats?";

////////////////////////
export const GET_FILTER_VENDOR_CHECKOUT: string =
  "http://" + API_BASE_URL + "/inventory/vendorCheckout/filter";
  
export const GET_REASONS_BY_TYPE: string =
  "http://" + API_BASE_URL + "/followUpReasonMaster/all?type=";

export const SAVE_ISSUES: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/save";

export const SAVE_CUSTOMER_TASK_ASSIGN: string =
  "http://" + API_BASE_URL + "/taskAssign/save";

export const GET_CAF_CUSTOMER_URL: string =
  "http://" + API_BASE_URL + "/subCafCustomers/all?customerId=";
export const CREATE_PDF_URL: string =
  "http://" + API_BASE_URL + "/subCafCustomers/cafpdf?customerId=";

//invetory addresss
export const GET_INVENTORY_ADDRESS_BY_COLUMN: string =
  "http://" + API_BASE_URL + "/locations/filter";

export const REVERT_EKYC_PAYMENT: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/updateRevertStatus"

export const GET_ALL_LOCATION: string =
  "http://" + API_BASE_URL + "/locations/all";

export const DELETE_LOCATION: string =
  "http://" + API_BASE_URL + "/locations/";

export const UPDATE_LOCATION: string =
  "http://" + API_BASE_URL + "/locations/update";

export const ADD_NEW_LOCATION: string =
  "http://" + API_BASE_URL + "/locations/save";

export const GET_EXCEL_LOCATION_MASTER: string =
  "http://" + API_BASE_URL + "/locations/all";

export const GET_EKYC_ONLINE_PAYMENTS: string =
  "http://" + API_BASE_URL + "/mobilePay/allEkycPayment?";

export const GET_CRM_ONLINE_PAYMENTS: string =
  "http://" + API_BASE_URL + "/mobilePay/allCrmBillPayment?";

// export const GET_INVENTORY_ADDRESS_BY_COLUMN: string =
//   "http://" + API_BASE_URL + "/locations/filter";

// NEW DEPARTMENTS API
export const POST_DEPARTMENT: string =
  "http://" + API_BASE_URL + "/departmentMaster/save";

export const UPDATE_DEPARTMENT: string =
  "http://" + API_BASE_URL + "/departmentMaster/update"

export const GET_ALL_DEPARMENTS: string =
  "http://" + API_BASE_URL + "/departmentMaster/all";

export const GET_DEPARTMENT_BY_ITS_ID: string =
  "http://" + API_BASE_URL + "/departmentMaster/";

// GENERIC REASONS API
export const GET_ALL_GENERIC_REASONS: string =
  "http://" + API_BASE_URL + "/reasonMaster/all";

// GENERIC ISSUE REASONS API
export const GET_ISSUE_GENERIC_REASONS: string =
  "http://" + API_BASE_URL + "/reasonMaster/departmentOrType?type=ISSUE_REASON";
export const GET_LCO_GENERIC_REASONS: string =
  "http://" + API_BASE_URL + "/reasonMaster/departmentOrType?type=LCO_REASON";
export const GET_GEN_REASONS_DEPT_ID: string =
  "http://" + API_BASE_URL + "/reasonMaster/departmentOrType?departmentId=";
export const GET_GEN_REASONS_CABLE_TV: string =
  "http://" + API_BASE_URL + "/reasonMaster/departmentOrType?type=CABLE_TV_REASON";
export const SAVE_REASON_GENERIC_MASTER: string =
  "http://" + API_BASE_URL + "/reasonMaster/save";
export const GET_GENERIC_REASON_BY_ITS_ID: string =
  "http://" + API_BASE_URL + "/reasonMaster/";
export const UPDATE_GENERIC_REASONS: string =
  "http://" + API_BASE_URL + "/reasonMaster/update"
export const DELETE_GENERIC_REASONS: string =
  "http://" + API_BASE_URL + "/reasonMaster/";

//generic crm
export const SAVE_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/save"
export const UPDATE_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/update"
export const GET_BY_ID_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/"
export const ASSIGN_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/assign";
export const STATUS_CHANGE_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/updateStatus";
export const GENERIC_CRM_FOLLOW_UP: string =
  "http://" + API_BASE_URL + "/genericCrmFollowUp/save";
//generic crm tiket
export const GENERIC_CRM_TICKET_HISTORY: string =
  "http://" + API_BASE_URL + "/genericCrm/crmUser/";

// TEAM ASSIGNMENT API'S
export const GET_ALL_TEAM_ASSIGNED: string =
  "http://" + API_BASE_URL + "/teamAssignment/all";
export const GET_BY_TEAM_ASSIGNMENT_ID: string =
  "http://" + API_BASE_URL + "/teamAssignment/";

export const SAVE_TEAM_ASSIGNMENT: string =
  "http://" + API_BASE_URL + "/teamAssignment/save";
export const UPDATE_TEAM_ASSIGNMENT: string =
  "http://" + API_BASE_URL + "/teamAssignment/update";

export const DELETE_TEAM_ASSIGNED: string =
  "http://" + API_BASE_URL + "/teamAssignment/";

export const GET_ALL_GENRIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/all";
export const GET_GENRIC_CRM_STATUS: string =
  "http://" + API_BASE_URL + "/genericCrm/departmentOrStatus?status=";

export const GET_GENRIC_ALL_STATUS: string =
  "http://" + API_BASE_URL + "/genericCrm/allStats?";
export const DELETE_GENRIC_CRM_BY_ID: string =
  "http://" + API_BASE_URL + "/genericCrm/";

//GENERIC CRM FILTERS
export const FILTER_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/filter?"

export const FILTER_DIS_INV_GENERIC_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/department?";

export const GET_CUSTOMER_LIST_BY_ID: string =
  "http://" + API_BASE_URL + "/crmUserAccount/userSearch"

export const DISCONNECTION_INVENTORY_URL: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/inventoryCollected?"

export const DISCONNECTION_REQUEST: string =
  "http://" + API_BASE_URL + "/crmDisconnectionRequest/";

// customer inventory detail popup
export const GET_CUSTOMER_INVENTORY_DETAILS_POPUP: string =
  "http://" + API_BASE_URL + "/inventory/assign/crmUser/";

export const GET_ALL_CRM_PARTNERS: string =
  "http://" + API_BASE_URL + "/crmPartner/all";

export const GET_ALL_CRM_RESELLER: string =
  "http://" + API_BASE_URL + "/crmReseller/all";

export const GET_ALL_CRM_RESELLER_BY_PARTNER: string =
  "http://" + API_BASE_URL + "/crmReseller/all";

export const UPDATE_RESELLER_LIST: string =
  "http://" + API_BASE_URL + "/crmReseller/updateList?partnerName=";
export const UPDATE_CRM_PARTNER_LIST: string =
  "http://" + API_BASE_URL + "/crmPartner/updateList";

export const UPDATE_NO_PAYMENT_COLLECTION: string =
  "http://" + API_BASE_URL + "/crm/noCollections/updateRemark"

export const FILTER_GENERIC_REASON: string =
  "http://" + API_BASE_URL + "/reasonMaster/filter?"

export const POST_ESCALATION_DATA: string =
  "http://" + API_BASE_URL + "/escalation/save";

export const UPDATE_ESCALATION_DATA: string =
  "http://" + API_BASE_URL + "/escalation/update";

export const GET_ESCALATION_DATA: string =
  "http://" + API_BASE_URL + "/escalation/all";

export const GET_EKYC_POST_CHARGE: string =
  "http://" + API_BASE_URL + "/crmCharge/all";

export const GET_FILTER_POST_CHARGE: string =
  "http://" + API_BASE_URL + "/crmCharge/filter?";

export const GET_EKYC_POST_PAYMENT: string =
  "http://" + API_BASE_URL + "/ekycPostPayment/all"

export const GET_EKYC_POST_CHARGE_RETRY: string =
  "http://" + API_BASE_URL + "/crmCharge/retry"

export const EKYC_POST_PAYMENT_RETRY: string =
  "http://" + API_BASE_URL + "/ekycPostPayment/retry/";



export const GET_FILTER_EKYC_POST_PAYMENT: string =
  "http://" + API_BASE_URL + "/ekycPostPayment/filter?"

export const GET_EMPLOYE_WITH_ASSIGNED_INV: string =
  "http://" + API_BASE_URL + "/inventory/query/allAssignSalesman";

export const UPDATE_INVENTORY_ASSIGN_STATUS: string =
  "http://" + API_BASE_URL + "/customers/updateInventoryAssign";

export const ASS_GEN_CRM_INV_COL: string =
  "http://" + API_BASE_URL + "/genericCrm/updateInvCollectionAssign";

export const STATUS_CHANE_INV_GEN_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/updateInvCollectionStatus";

export const COLLECT_INVENTORY_GEN_CRM: string =
  "http://" + API_BASE_URL + "/inventoryCollection/saveList";

export const UPDATE_CRM_PARTNER: string =
  "http://" + API_BASE_URL + "/crmPartner/update";

export const UPDATE_CRM_RESELLER: string =
  "http://" + API_BASE_URL + "/crmReseller/update";

export const GET_ALL_BANK: string =
  "http://" + API_BASE_URL + "/crmBank/all";

export const CRM_CUSTOMER_DUES: string =
  "http://" + API_BASE_URL + "/crmUserAccountDues/duesFilter";

export const CRM_CUSTOMER_ACCOUNT_DUES: string =
  "http://" + API_BASE_URL + "/crmUserAccountDues/filter?";

export const CRM_CUSTOMER_ACCOUNT_SYNC_DUES: string =
  "http://" + API_BASE_URL + "/crmUserAccountDues/syncDues?";

export const SAVE_USER_COLLECTION_MAPPING: string =
  "http://" + API_BASE_URL + "/crmDuesMapping/save";

export const GET_USER_COLLECTION_MAPPING: string =
  "http://" + API_BASE_URL + "/crmDuesMapping/all";

export const DELETE_USER_MAPPING: string =
  "http://" + API_BASE_URL + "/crmDuesMapping/";

export const POST_PAYMENT: string =
  "http://" + API_BASE_URL + "/integration/paymentCollection";

export const GET_INV_COLL_BY_EMP: string =
  "http://" + API_BASE_URL + "/inventoryCollection/collectedByEmp?empId=";

export const POST_STORE_KEEPER_REQUEST: string =
  "http://" + API_BASE_URL + "/inventoryStockkeeper/save";

export const GET_ALL_STOREKEEPER_ASSIGNMENT: string =
  "http://" + API_BASE_URL + "/inventoryStockkeeper/all";

export const UPDATE_STORE_KEEPER_REQUEST: string =
  "http://" + API_BASE_URL + "/inventoryStockkeeper/update";
export const DELETE_STORE_KEEPER_BY_ID: string =
  "http://" + API_BASE_URL + "/inventoryStockkeeper/"

export const GET_CASHIER_DAYBOOK_STATS: string =
  "http://" + API_BASE_URL + "/crm/paymentCollection/cashierStats?";

export const GET_CASHIER_DAYBOOK_STATS_EKYC: string =
  "http://" + API_BASE_URL + "/cafCustomerPayment/cashierStats?";

export const GET_INV_COLL_REQUEST: string =
  "http://" + API_BASE_URL + "/inventoryCollection/stockEmployee?";

export const GET_INV_COLL_EMP_BY_STORE_KEEPER: string =
  "http://" + API_BASE_URL + "/inventoryCollection/inventoryInHandWithEmp?"

export const GET_INV_COLL_BY_FILTER: string =
  "http://" + API_BASE_URL + "/inventoryCollection/filter?";

export const GET_INV_SUBMIT_REQUEST: string =
  "http://" + API_BASE_URL + "/inventory/replacement/stockEmployee?";

export const GET_INV_SUBMIT_BY_FILTER:string =
 "http://"+ API_BASE_URL + "/inventory/replacement/stockEmployee/filter?"

export const UPDATE_INV_SUBMISSION_REQ_REPLACE: string =
  "http://" + API_BASE_URL + "/inventory/replacement/updateStockStatus";

export const UPDATE_INV_SUBMISSION_REQ: string =
  "http://" + API_BASE_URL + "/inventoryCollection/updateStockStatus"

export const POST_CASHIER_ASSIGNMENT_REQUEST: string =
  "http://" + API_BASE_URL + "/cashierUserMapping/save";

export const UPDATE_CASHIER_ASSIGNMENT_REQUEST: string =
  "http://" + API_BASE_URL + "/cashierUserMapping/update";

export const GET_ALL_CASHIER_ASSIGNMENT: string =
  "http://" + API_BASE_URL + "/cashierUserMapping/all";

export const DELETE_CASHIER_BY_ID: string =
  "http://" + API_BASE_URL + "/cashierUserMapping/";
export const GET_FILTER_INVENTORY_HISTORY_RETURN: string =
  "http://" + API_BASE_URL + "/inventory/assign/returnFilter?"
export const GET_STATUS_HISTORY_BY_GEN_CRM_ID: string =
  "http://" + API_BASE_URL + "/genericCrm/history";
export const GET_FOLLOW_UP_HISTORY_BY_GEN_CRM_ID: string =
  "http://" + API_BASE_URL + "/genericCrmFollowUp/history";
export const GET_CRM_USER_BY_USER_ID: string =
  "http://" + API_BASE_URL + "/crmUserAccount/";

export const GET_COLL_INV_BY_USER_ID: string =
  "http://" + API_BASE_URL + "/inventoryCollection/collectedHistory/";

export const GET_OLD_INSTALL_INVENTORY: string =
  "http://" + API_BASE_URL + "/oldInstallInventory/all?";


export const GET_ACTION_HISTORY: string =
  "http://" + API_BASE_URL + "/userHistory/all?";

export const GET_AUDIT_USER_DETAILS: string =
  "http://" + API_BASE_URL + "/userHistory/auditUser/";

export const GET_ALL_GENERIC_CRM_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/allStatsNew?";

export const GET_ALL_DATE_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/datewiseEmpStats?";


export const GET_ALL_DATE_STATS_DETAILS: string =
  "http://" + API_BASE_URL + "/genericCrm/details?";

export const GET_ALL_PENDING_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/pendingStats?";

export const GET_DATE_WISE_STATS_GEN_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/datewiseStats?";

export const GET_ALL_PENDING_DETAILS_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/pendingDetails?";


export const GET_DATE_WISE_EMP_STATS_GEN_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/datewiseEmpStats?";

export const GET_GEN_ANALYSIS_TABLE3: string =
  "http://" + API_BASE_URL + "/genericCrm/currentStatusStats?";

export const UPDATE_PASSWORD: string =
  "http://" + API_BASE_URL + "/users/changePassword";

export const GEN_CRM_DATEWISE_PENDING_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/datewiseEmpPendingStats?";

export const GEN_CRM_PENDING_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/datewisePendingStats?";

export const GET_PENDING_DATE_WISE_EMP_STATS_GEN_CRM: string =
  "http://" + API_BASE_URL + "/genericCrm/employeewisePendingStats?"

export const GEN_ANAL_DATEWISE_PENDING_CURRENT_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/datewisePendingCurrentStatusStats?"

export const GEN_ANAL_EMPWISE_PENDING_CURRENT_STATS: string =
  "http://" + API_BASE_URL + "/genericCrm/employeewisePendingCurrentStatusStats?"

export const GEN_ANALYSIS_DATEWISE_PENDING_DETAILS: string =
  "http://" + API_BASE_URL + "/genericCrm/datewisePendingDetails?"

export const GEN_ANALYSIS_EMPWISE_PENDING_DETAILS: string =
  "http://" + API_BASE_URL + "/genericCrm/employeewisePendingDetails?"
// /subCafCustomers/cafpdf?customerId=412&subCafCustomerId=10

export const UPDATE_CUSTOMER: string =
  "http://" + API_BASE_URL + "/crmUserAccount/updateCustomer"

export const POST_OTP_REQUEST: string =
  "http://" + API_BASE_URL + "/otp/send";

export const GET_OTP_VERIFIED: string =
  "http://" + API_BASE_URL + "/otp/verify";

export const POST_CLICK_TO_CALL_DATA: string =
  "http://192.168.0.31/pbxadmin/sanpbxapi";

export const GET_ALL_NEW_REPLACEMENT: string =
  "http://" + API_BASE_URL + "/inventory/replacement/allNew";

export const GET_ALL_LOCATION_BY_RESELLER: string =
  "http://" + API_BASE_URL + "/locations/filterNew";

export const GET_ALL_OTP_DETAILS: string =
  "http://" + API_BASE_URL + "/otp/all";

export const GET_ALL_RECORDING_DETAILS: string =
  "http://" + API_BASE_URL + "/recording/all";

export const GET_NOTIFICATION_DETAILS: string =
  "http://" + API_BASE_URL + "/inventoryNotificationAlert/companyAndProduct?";

export const GET_ALL_ALERT_DETAILS: string =
  "http://" + API_BASE_URL + "/alert/all?";

export const GET_LOCATION_TYPE_MASTER: string =
  "http://" + API_BASE_URL + "/locationTypeMaster/";

export const GET_STATE_MASTER: string =
  "http://" + API_BASE_URL + "/stateMaster/";

export const GET_CITY_MASTER: string =
  "http://" + API_BASE_URL + "/cityMaster/";

export const GET_AREA_MASTER: string =
  "http://" + API_BASE_URL + "/areaMaster/";

export const GET_SUBAREA_MASTER: string =
  "http://" + API_BASE_URL + "/subareaMaster/";

export const GET_TOWER_MASTER: string =
  "http://" + API_BASE_URL + "/towerMaster/";

export const GET_FLOOR_MASTER: string =
  "http://" + API_BASE_URL + "/floorMaster/";

export const GET_STREET_MASTER: string =
  "http://" + API_BASE_URL + "/streetMaster/";

export const GET_POLE_MASTER: string =
  "http://" + API_BASE_URL + "/poleLocationMaster/";

export const GET_HOUSE_MASTER: string =
  "http://" + API_BASE_URL + "/houseNumberMaster/";
export const GET_PARTNER_RESELLER_BY_EMPID:string = "http://"+API_BASE_URL + "/users/crmPartnerResellers?userId="

export const EKYC_CREATE_ACCOUNT:string =
"http://" + API_BASE_URL + "/customers/createAccountH8/"
export const EKYC_POST_PAYMENT_H8:string =
"http://" + API_BASE_URL + "/customers/addPaymentH8/"

export enum TaskCode {
  GET_CUSTOMER_INVENTORY_DETAILS_POPUP,
  GET_CITY,
  UPLOAD_CITY_EXCEL,
  GET_AREAS,
  GET_ALL_COMPANY_SERVICES,
  UPDATE_EKYC_CAF_PAYMENT,
  SAVE_EKYC_CAF_PAYMENT,
  UPDATE_ONLINE_PAYMENT,
  GET_ALL_COMPANY_BRANCHES,
  GET_DEP_BY_COMPANY_ID_URL,
  GET_ALL_ROLES,
  GET_ALL_PLANS,
  GET_ALL_INACTIVE_PLANS,
  UPDATE_PLAN_ACTIVE_STATUS,
  GET_PLAN_BY_ID_URL,
  ADD_NEW_PLAN,
  UPDATE_PLAN,
  UPDATE_AREA,
  GET_AREA,
  GET_DETPARTMENT_BY_ID,
  FILE_UPLOAD,
  ADD_PRODUCT,
  DELETE_PRODUCT_ITEM_API,
  GET_PRODUCT_ITEM_BY_ID_API,
  SAVE_NEW_USER,
  UPDATE_USER_ACTIVE_STATUS,
  UPLOAD_IMAGE_URL,
  UPLOAD_OLD_INSTALL_INVENTORY,
  GET_USER_BY_USERID,
  UPDATE_USER_URL,
  UPDATE_PRODUCT_URL,
  DELETE_CATEGORY_API,
  SAVE_COMPANY_SERVICE,
  GET_ALL_VENDOR,
  GET_ALL_CATEGORY,
  GET_PRODUCT_ITEMS_BY_CATEGORY_ID,
  GET_ALL_TASK,
  UPDATE_STATUS_TASK_URL,
  UPDATE_WHATSAPP_LINK_STATUS_URL,
  GET_TASK_BY_ID,
  GET_ALL_CUSTOMER_DOCUMENTS,
  SAVE_TASK_URL,
  UPDATE_TASK_URL,
  DELETE_TASK_URL,
  GET_BY_TASK_DATE_URL,
  GET_TASK_STATUS_URL,
  FITLER_TASK_URL,
  TASK_STATS_URL,
  INVENTORY_CHECKIN_SAVE,
  INVENTORY_CHECKIN_UPDATE_CHECKOUT,
  INVENTORY_ASSIGN_UPDATE_CONFIRM,
  GET_CATEGORY_BY_ID,
  GET_INVENTORY_BY_ID,
  INVENTORY_CHECKIN_UPDATE,
  GET_USERS_BY_SEARCH,
  GET_ATTENDANCE_USERS_BY_SEARCH,
  GET_USERS_BY_MOBILE_SEARCH,
  GET_USER_BY_ID,
  GET_MANAGER_BY_SEARCH,
  GET_ALL_INVENTORY,
  GET_LOGIN_URL,
  GET_INVENTORY_DETAILS_BY_PRODUCT_ID,
  INVENTORY_DETAILS_BY_PRODUCT_AND_COMPANY_ID,
  GET_ALL_USER,
  GET_ALL_ATTENDANCE,
  SAVE_USER_ATTENDANCE,
  UPDATE_USER_ATTENDANCE,
  SAVE_USER_LIST_ATTENDANCE,
  GET_ATTENDANCE_BY_USER_ID,
  GET_ALL_EMPLOYEE_BY_REPORTING_MANAGER,
  GET_ALL_EMPLOYEE_EXCEL_FORMAT,
  GET_CUSTOMER_BY_PAGE,
  GET_CUSTOMER_BY_STATUS_PAGE,
  REUPDATE_COMPLETE_CAF,
  GET_PAYMENT_LATER_CUSTOMER,
  UPDATE_PAYMENT_LATER_STATUS,
  SAVE_CUSTOMER_TASK_ASSIGN,

  UPDATE_CUSTOMER_PAYMENT_STATUS,
  UPDATE_CUSTOMER_EKYC_STATUS,
  UPDATE_CUSTOMER_WORK_STATUS,
  UPDATE_EKYC_CUSTOMER_STATUS,

  GET_EKYC_REPORT_STATUS,
  GET_ALL_EKYC_PAYMENT,
  GET_EKYC_PAYMENT_FILTER,
  UPDATE_EKYC_PAYMENT_SUMMARY_STAT,
  GET_EKYC_PAYMENT_SUMMARY_STAT,
  GET_EKYC_EMPLOYEE_PAYMENT_STAT,
  GET_EKYC_DAY_BOOK_PAYMENT_RECEIVED_STATUS,
  GET_EKYC_EMPLOEE_STATS,
  GET_EKYC_EMPLOYEE_REPORT_STATUS,

  UPDATE_FOLLOWUP_CUSTOMER_STATUS,
  UPDATE_CUSTOMER_ACTIVE_STATUS,
  FILTER_USER_BY_QUERY,
  GET_USERS_BY_PAGE,
  GET_USER_BY_MOBILE_NUMBER,
  GET_ALL_INVENTORY_QUERY,
  FILTER_STOCK_INVENTORY_QUERY,
  GET_INVENTORY_UNASSIGNED_ITEMS,
  ASSIGN_SALESMAN_INVENTORY,
  MULTIPLE_ASSIGN_SALESMAN_INVENTORY,
  // GET_ALL_BANK_BRANCH,
  GET_PRODUCT_ITEM_BY_CATEGORY_ID,
  PRODUCT_ITEM_BY_CAT_COMPANY_ID,
  DEL_USER_BY_USER_ID,
  DELETE_VENDOR,
  DEL_COMPANY_BY_ID_URL,
  DELETE_COMPANY_SERVICE,
  DEL_CITY_BY_ID_URL,
  DEL_PLAN_BY_PLAN_ID,
  DELETE_COMPANY_DEPARTMENT_URL,
  DEL_CITY_AREA,
  //subarea

  GET_ALL_SUBAREA_URL,
  SAVE_SUBAREA_URL,
  GET_SUBAREA_BY_AREAID_URL,
  UPDATE_SUBAREA_URL,
  DELETE_SUBAREA_URL,

  //
  INVENTORY_QUERY_API,
  INVENTORY_HISTORY_BY_ASSIGNED_TYPE,
  GET_ALL_PARTNERS,
  GET_PARTNER_BY_PARTNER_ID,
  SAVE_PARTNER,
  UPDATE_PARTNER,
  DELETE_PARTNER,
  GET_CATEGORY_EMBED,
  GET_CUSTOMER_BY_ID,
  UPDATE_EKYC_CUSTOMER_BY_ID,
  GET_CUSTOMER_BY_SUB_CAF_ID,
  REPLACE_CUSTOMER_PRODUCT,
  FILTER_INVENTORY_BY_QUERY,
  FILTER_CUSTOMER,
  FILTER_EKYC_CUSTOMER,
  INVENTORY_HISTORY_PAGES_ASSIGNED_TYPE,
  RETURN_CUSTOMER_PRODUCT,
  GET_ALL_REPLACEMENT,
  VENDOR_CHECKOUT,
  RETURN_BACK_FROM_REPLACEMENT,
  GET_VENDOR_CHECKOUT_ITEMS,
  GET_CATEGORY_EMBED_WITH_COMPANY,
  GET_ASSIGNED_EMPLOYEES,
  VENDOR_ACTIONS_API,
  BY_ASSIGN_TYPE_FILTER,
  REVERT_INVENTORY,
  GET_ALL_PRODUCT,
  FILTERED_REVERT_INVENTORY,
  DISTRIBUTION_API,
  GET_USERS_BY_PAGE_N_COMPANY,
  GET_DISTRIBUTION_BY_TYPECODE,
  GET_REPORT_STATS,
  GET_REPORT_DETAIL,
  GET_PRODUCT_SEARCH_DETAIL,
  GET_GLOBAL_DATA,
  GET_ALL_CHARGE_URL,
  DEL_CHARGES_URL,
  UPDATE_CHARGE_URL,
  POST_CHARGE_URL,
  GET_CHARGE_BY_ID_URL,
  GET_ALL_EMPLOYEE_ROLE_URL,
  DEL_EMPLOYEE_ROLE_URL,
  UPDATE_EMPLOYEE_ROLE_URL,
  POST_EMPLOYEE_ROLE_URL,
  GET_EMPLOYEE_ROLE_BY_ID_URL,
  GET_ALL_PRODUCT_CONDITION_URL,
  DEL_PRODUCT_CONDITION_URL,
  UPDATE_PRODUCT_CONDITION_URL,
  SAVE_PRODUCT_CONDITION_URL,
  GET_PRODUCT_CONDITION_BY_ID_URL,
  DEL_REASONS_URL,
  GET_EKYC_REPORT,
  GET_PAYMENT_COLLECTION_REPORT,
  GET_NO_COLLECTION_REPORT,
  GET_PAYMENT_COLLECTION_REPORT_FILTER,
  GET_NO_COLLECTION_REPORT_FILTER,

  GET_USER_DETAIL,
  GET_USER_DETAIL_BY_NUMBER,
  GET_EMPLOYEE_BY_DATE,

  GET_ALL_FUNNEL_CUSTOMER,
  GET_FUNNEL_CUSTOMER_BY_ID,
  GET_FILTER_FUNNEL_CUSTOMER,
  UPDATE_FUNNEL_CUSTOMER,
  SAVE_FUNNEL_CUSTOMER,
  DELETE_FUNNEL_CUSTOMER,
  GET_FUNNEL_CUSTOMER_BY_STATUS,
  UPDATE_STATUS_FUNNEL_CUSTOMER,

  RESET_USER_DEVICE_ID,
  GET_PAYMENT_STATS,
  UPDATE_PAYMENT_STATUS,
  GET_EMPLOEE_STATS,
  UPDATE_EMPLOEE_STATS,
  GET_EMPLOYEE_TRACKING_BY_DATE,
  GET_EMPLOYEE_TRACKING_DETAILS,
  GET_PAYMENT_RECEIVED_STATUS,

  EDIT_ASSIGN_SALESMAN_INVENTORY,
  ///followUp

  GET_ALL_FOLLOWUP_URL,
  GET_FOLLOWUP_BY_ID_URL,
  SAVE_FOLLOWUP_URL,
  // lead/
  GET_ALL_LEAD_URL,
  GET_LEAD_BY_ID_URL,
  SAVE_LEAD_URL,
  UPDATE_LEAD_URL,
  UPDATE_STATUS_LEAD_URL,
  GET_ALL_LEAD_BY_STATUS,
  ADD_NEW_REASON,
  GET_ALL_REASONS,
  DELEATE_REASONS,
  GET_ALL_LEAD_FILTER,
  CLOSE_LEAD_URL,
  GET_LEAD_CUSTOMER_BY_ID,
  //////////////////////area

  GET_AREA_BY_CITY_ID,
  //collection report
  GET_ALL_DISCONNECTION,
  GET_ALL_CONNECTION_ISSUE,
  GET_CONNECTION_ISSUE_FILTER,
  GET_DISCONNECTION_FILTER,
  REVERT_POST_PAYMENT_COLLECTION_REPORT,

  //DiscountRule
  GET_ALL_DISCOUNT_URL,
  GET__DISCOUNT_BY_ID_URL,
  ADD_DISCOUNT_URL,
  UPDATE_DISCOUNT_URL,
  DELETE_DISCOUNT_URL,

  //////team
  GET_ALL_TEAM_URL,
  GET_ALL_TEAM_NAME_URL,
  GET_TEAM_BY_ID_URL,
  ADD_TEAM_URL,
  UPDATE_TEAM_URL,
  DELETE_TEAM_URL,
  //Reasons
  EDIT_REASON,

  CRM_STATS_URL,
  CRM_STATS_BY_SOURCE,
  DISCONNECTION_STATS_URL,
  COLLECTION_STATS_URL,
  EKYC_STATS_URL,

  UPDATE_CON,
  GET_CON_BY_STATUS,
  GET_CON_BY_ID,
  UPDATE_STATUS_COMPLAINT,
  GET_FILTER_VENDOR_CHECKOUT,
  GET_REASONS_BY_TYPE,
  SAVE_ISSUES,
  //////////////////stats
  GET_CRMSTATS_EMPLOYEESTATS,
  GET_CAF_CUSTOMER_URL,
  CREATE_PDF_URL,
  //address inventory
  GET_ALL_INVENTORY_SERVICE_AREA,
  GET_INVENTORY_SECTORY_BY_CITY,
  GET_INVENTORY_BLOCK_BY_SECTOR,
  GET_INVENTORY_TOWER_BY_BLOCK,
  GET_INVENTORY_FLOOR_BY_TOWER,
  REVERT_EKYC_PAYMENT,
  //location-master
  GET_ALL_LOCATION,
  DELETE_LOCATION,
  UPDATE_LOCATION,
  ADD_NEW_LOCATION,
  GET_EXCEL_LOCATION_MASTER,
  GET_FILTERED_LOCATION,

  GET_EKYC_ONLINE_PAYMENTS,

  GET_CRM_ONLINE_PAYMENTS,

  //NEW DEPARTMENT
  GET_ALL_DEPARMENTS,
  CREATE_DEPARTMENT,
  UPDATE_DEPARTMENT,
  GET_DEPARTMENT_BY_ID,
  DELETE_DEPARTMENT,
  // generic reasons
  GET_ALL_GENERIC_REASONS,
  GET_ISSUE_GENERIC_REASONS,
  GET_GEN_REASONS_DEPT_ID,
  SAVE_REASON_GERERIC_MASTER,
  GET_REASON_GERERIC_BY_ID,
  UPDATE_GENERIC_REASONS,
  DELETE_GENERIC_REASONS,
  // generic crm
  SAVE_GENERIC_CRM,
  ASSIGN_GENERIC_CRM,
  UPDATE_GENERIC_CRM,
  GET_BY_GENERIC_CRM_REQUEST,
  GENERIC_CRM_FOLLOW_UP,
  STATUS_CHANGE_GENERIC_CRM,
  GENERIC_CRM_TICKET_HISTORY,
  // team assignment
  GET_ALL_TEAM_ASSIGNED,
  GET_BY_TEAM_ASSIGNMENT_ID,
  // GET_ALL_INVENTORY_SERVICE_AREA,
  // GET_INVENTORY_SECTORY_BY_CITY,
  SAVE_TEAM_ASSIGNMENT,
  DELETE_TEAM_ASSIGNED,
  GET_ALL_GENRIC_CRM,
  GET_GENERIC_CRM_STATUS,
  GET_GENERIC_CRM_ALL_STATUS,
  DELETE_GENERIC_CRM_BY_ID,
  //generic crm filter
  FILTER_GENERIC_CRM,
  GET_CUSTOMER_LIST_BY_ID,
  ASSIGN_DISCONNECTION_INVENTORY,
  UPDATE_DIS_INVENTORY_STATUS,
  GET_ALL_SUPERVISER,
  GET_ALL_SUPERVISER_HEAD,
  GET_ALL_CRM_RESELLER,
  GET_ALL_CRM_RESELLER_BY_PARTNER,
  UPDATE_RESELLER_LIST,
  UPDATE_PARTNER_LIST,
  UPDATE_NO_PAYMENT_COLLECTION,
  UPDATE_PASSWORD,
  UPDATE_CUSTOMER_DETAILS,
  FILTER_GENERIC_REASON,
  POST_ESCALATION_DATA,
  GET_ESCALATION_DATA,
  GET_EKYC_POST_CHARGE,
  GET_EKYC_POST_PAYMENT,
  GET_EKYC_POST_CHARGE_RETRY,
  UPDATE_INVENTORY_ASSIGN_STATUS,
  SAVE_ROLES_AND_PERMISSIONS,
  GET_ROLE_BY_ID,
  UPDATE_ROLES_AND_PERMISSIONS,
  EKYC_POST_PAYMENT_RETRY,
  COLLECT_INVENTORY_GEN_CRM,
  UPDATE_CRM_PARTNER,
  UPDATE_CRM_RESELLER,
  CRM_CUSTOMER_DUES,
  CRM_CUSTOMER_ACCOUNT_DUES,
  FILTER_CRM_CUSTOMER_ACCOUNT_DUES,
  CRM_CUSTOMER_ACCOUNT_SYNC_DUES,
  CUSTOMER_DUES_STATUS,
  SAVE_COLLECTION_MAPPING,
  GET_ALL_BANK,
  POST_PAYMENT,
  POST_OTP_REQUEST,
  GET_OTP_VERIFIED_BY_NUMBER,
  GET_INV_COLL_BY_EMP,
  POST_STORE_KEEPER_REQUEST,
  GET_ALL_STOREKEEPER_ASSIGNMENT,
  DELETE_STORE_KEEPER_BY_ID,
  GET_CASHIER_DAYBOOK_STATS,
  GET_INV_COLL_REQUEST,
  GET_INV_SUBMIT_REQUEST,
  UPDATE_INV_SUBMISSION_REQ,
  UPDATE_INV_EMP_REQ,
  GET_USER_COLLECTION_MAPPING,
  DELETE_USER_MAPPING,
  POST_CASHIER_ASSIGNMENT_REQUEST,
  GET_ALL_CASHIER_ASSIGNMENT,
  DELETE_CASHIER_BY_ID,
  GET_FILTER_INVENTORY_HISTORY_RETURN,
  GET_COLL_AGENT_MAP_BY_ID,
  GET_STATUS_HISTORY,
  GET_FOLLOW_UP_HISTORY,
  GET_COLL_INV_BY_USERID,
  GET_OLD_INSTALL_INVENTORY,
  GET_ALL_GENERIC_CRM_STATS,
  GET_ALL_GENERIC_CRM_DATEWISE,
  GET_ALL_GENERIC_CRM_DATEWISE_DETAILS,
  GET_ALL_PENDING_STATS,
  GET_ALL_PENDING_DETAILS_STATS,
  GET_ALL_GENERIC_CRM_DATEWISE_EMP,
  GET_ANALYSIS_TABLE3_DATA,
  GET_ALL_ACTION_HISTORY,
  GET_ALL_AUDIT_USER_DETAILS,
  POST_CLICK_TO_CALL_DATA,
  GET_ALL_REPLACEMENT_NEW,
  GET_ALL_RESELLER_SERVICE_AREA,
  // GET_RESELLER_BY_CITY,
  GET_RESELLER_BLOCK_BY_SECTOR,
  GET_RESELLER_TOWER_BY_BLOCK,
  GET_RESELLER_FLOOR_BY_TOWER,
  GET_RESELLER_SECTORY_BY_CITY,
  GET_OTP_DETAILS,
  GET_RECORDING_DETAILS,
  GET_INVENTORY_PRODUCT_DETAILS,
  GET_ALERT_DETAILS,
  CREATE_LOCATION,
  EDIT_LOCATION,
  GET_ALL_LOCATION_RESELLER,
  GET_ALL_TYPE,
  GET_ALL_STATE_RESELLER,
  GET_ALL_CITY_RESELLER,
  GET_ALL_AREA_RESELLER,
  GET_ALL_SUBAREA_RESELLER,
  GET_ALL_TOWER_RESELLER,
  GET_ALL_FLOOR_RESELLER,
  GET_ALL_STREET_RESELLER,
  GET_ALL_HOUSE_RESELLER,
  GET_LOCATION_BY_ID,
  DELETE_LOCATION_BY_ID,
  GET_PARTNER_RESELLER_BY_EMPID,
  EKYC_CREATE_ACCOUNT,
  EKYC_POST_PAYMENT_H8,
  GET_INV_DETAILS_OF_EMP,
  GET_ALL_PLAN_BY_CITY_AREA_SERVICE
}

export enum DocumentType {
  PAN_CARD = 1,
  DRIVING_LICENSE,
  VOTER_ID_CARD,
  PASSPORT,
  AADHAR,
  RATION_CARD,
  ElectricityorWater_Bill,
  RentAggreement,
  BankorPassbookStatement,
  CreditCardStatement,
  TelephoneBill
}

export enum AssignTaskTypeEnum {
  COLLECTION = "COLLECTION",
  PAYMENT = "PAYMENT",
  INVENTORY_INTERNAL = "INVENTORY_INTERNAL",
  COLLECTION_INVENTORY = "COLLECTION_INVENTORY",
  INVENTORY_COLLECTION = "INVENTORY_COLLECTION",
  INVENTORY_CUSTOMER = "INVENTORY_CUSTOMER",
}

export enum AssignTaskStatus {
  INITIATED = 1,
  COMPLETED
}

export enum InventoryTypeCode {
  EXTERNAL_CHECK_IN = 1,
  EXTERNAL_CHECK_OUT,
  INTERNAL_CHECK_IN,
  INTERNAL_CHECK_OUT
}

export enum EmployeeApiEnum {
  ViewAllEmployee = 1,
  ViewAssignedEmployee
}
export enum EmployeeApiWithStatus {
  ACTIVE_EMPLOYEE = "Active",
  INACTIVE_EMPLOYEE = "Inactive",
  ACTIVE_INACTIVE_EMPLOYEE = "Both_Status",
}

export enum CheckOutPurposeCode {
  EmployeeCheckout = 1,
  StockTransfer,
  Vendor_Checkout
}

export enum CategoryConsuptionTypeEnum {
  BOTH = 0,
  CUSTOMER = 1,
  INTERNAL = 2,
}

export enum CrmEnquiryStatusEnum {
  NEW = "NEW",
  ASSIGNED = "ASSIGNED",
  CONFIRMED = "CONFIRMED",
  FOLLOW_UP = "FOLLOW_UP",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  CLOSED = "CLOSED",
  LEAD_CREATED = "LEAD_CREATED",
  LEAD_ASSIGNED = "LEAD_ASSIGNED",
  LEAD_FOLLOW_UP = "FOLLOW_UP",
  LEAD_CONFIRMED = "LEAD_CONFIRMED",
  LEAD_CANCELLED = "LEAD_CANCELLED",
  LEAD_COMPLETED = "LEAD_COMPLETED",
  REFERRED_BY_SALES = "SALES",
  REFERRED_BY_ENQUIRY = "ENQUIRY",
  REFERRED_BY_CON = "CON",
  REFERRED_BY_TASK = "TP_TASK",
  REFERRED_BY_EKYC = "EKYC",
  REFERRED_BY_ACCOUNT = "ACCOUNT_ISSUE",
  REFERRED_BY_DISCON = "DISCON",
  PENDING = "PENDING",
  DISCONNECTION = "DISCONNECTION",
  HOLD = "HOLD",
  NON_PAYMENT = "NON_PAYMENT",
  CREATED_DISCONNECTION = "CREATED_DISCONNECTION",
  PENDING_PAYMENT = "PAYMENT_PENDING_EKYC_LEAD",
  INV_TO_BE_COLLECTED = "INVENTORY_COLLECTED_CREATE",
  INV_COLLECTION_ASSGINED = "INVENTORY_COLLECTED_ASSIGN",
  COLLECTED_INVENTORY = "INVENTORY_COLLECTED_COMPLETE",
  PENDING_CONFIRMATION_SALES = "PENDING_CONFIRMATION",
  PENDING_CONFIRMATION_ENQUIRY = "PENDING_CONFIRMATION"


}

export enum TaskStatusEnum {
  NEW = "NEW",
  ASSIGNED = "ASSIGNED",
  FOLLOW_UP = "FOLLOW_UP",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  CONFIRM = "CONFIRM",
  ALL = "ALL",
  CREATED = "CREATED_BY"
}



export enum CrmDashboardEnum {
  ALL_ENQUIRY = "ALL_ENQUIRY",
  ALL_ENQUIRY_CREATED = "ALL_ENQUIRY_CREATED",

  NEW_ENQUIRY = "NEW_ENQUIRY",
  ASSIGNED_ENQUIRY = "ASSIGNED_ENQUIRY",
  FOLLOWUP_ENQUIRY = "FOLLOWUP_ENQUIRY",
  CANCELLED_ENQUIRY = "CANCELLED_ENQUIRY",
  ALL_SALES = "ALL_SALES",
  ALL_SALES_CREATED = "ALL_SALES_CREATED",

  CONFIRMED_SALES = "CONFIRMED_SALES",
  ASSIGNED_SALES = "ASSIGNED_SALES",
  FOLLOWUP_SALES = "FOLLOWUP_SALES",
  CANCELLED_SALES = "CANCELLED_SALES",
  CLOSED_SALES = "CLOSED_SALES",

  PENDING_PAYMENT = "PAYMENT_PENDING_EKYC_LEAD",
  PENDING_CONFIRMATION_ENQUIRY = "PENDING_CONFIRMATION",
  PENDING_CONFIRMATION_SALES = "PENDING_CONFIRMATION"

}

export enum DateTypeEnum {
  Today = "Today",
  Yesterday = "Yesterday",
  Custom = "Custom",
  All = "All"
}

export enum CafTypeEnum {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PENDING_WIRING = "PENDING_WIRING",
  PENDING_FIBRE = "PENDING_FIBRE",
  PENDING_INSTALLATION = "PENDING_INSTALLATION",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  PENDING_INSTALLATION_AND_WIRING = "PENDING_INSTALLATION_AND_WIRING",
}
export enum UserType{
  TRIPLEPLAY = "TRIPLEPLAY_USER",
  LCO = "LCO_USER",
  ARM = "ARM_USER"
}

export enum CrmAccountDuesEnum {
  STATUS = "STATUS",
  DATA_SERVICE = "DATA_STATUS",
  SERVICE_AREA = "SERVICE_AREA",
  LOCATION_LEVEL1 = "LOCATION_LEVEL1",
  LOCATION_LEVEL2 = "LOCATION_LEVEL2",
  CRM_PARTNER = "CRM_PARTNER",
  CRM_RESELLER = "CRM_RESELLER",
}




export class InventoryType {
  id: number;
  name: string;
  isSelected: boolean;
  onlyMainBranch: boolean;

  constructor(id, name, isSelected, onlyMainBranch) {
    this.id = id;
    this.name = name;
    this.isSelected = isSelected;
    this.onlyMainBranch = onlyMainBranch;
  }

  public static getInventoryTypeList() {
    let array = new Array<InventoryType>();
    array.push(new InventoryType(1, "Check In", true, true));
    array.push(new InventoryType(2, "Check Out", false, false));
    array.push(new InventoryType(3, "Assigned", false, false));
    array.push(new InventoryType(4, "Replacement", false, false));
    array.push(new InventoryType(5, "Stock Transfer", false, false));
    array.push(new InventoryType(6, "Vendor Checkout", false, true));
    array.push(new InventoryType(7, "Stock In", false, false));
    array.push(new InventoryType(8, "Return", false, false));
    array.push(new InventoryType(9, "Inventory History", false, false));
    array.push(new InventoryType(10, "Replace New", false, false));
    return array;
  }
}

// export const InventoryGlobalClass: InventoryType[] = [
//   { id: 1, name: "Check In", isSelected: true ,onlyMainBranch: true },
//   { id: 2, name: "Check Out", isSelected: false, onlyMainBranch: false },
//   { id: 3, name: "Assigned", isSelected: false, onlyMainBranch: false},
//   { id: 4, name: "Replacement", isSelected: false, onlyMainBranch: false },
//   { id: 5, name: "Stock Transfer", isSelected: false, onlyMainBranch: false},
//   { id: 6, name: "Vendor Checkout", isSelected: false, onlyMainBranch: true},
//   { id: 7, name: "Stock In", isSelected: false, onlyMainBranch: false },
// ];








